import { render, staticRenderFns } from "./BarraTraduccion.vue?vue&type=template&id=6c001630&scoped=true"
import script from "./BarraTraduccion.vue?vue&type=script&lang=js"
export * from "./BarraTraduccion.vue?vue&type=script&lang=js"
import style0 from "./BarraTraduccion.vue?vue&type=style&index=0&id=6c001630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c001630",
  null
  
)

export default component.exports